var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"videoContainer",attrs:{"id":"video-container"}}),_c('div',{ref:"audioContainer",attrs:{"id":"audio-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }